import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Elements } from "@stripe/react-stripe-js";
import { BrowserRouter } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";

// Use your actual Stripe publishable key here
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Elements stripe={stripePromise}>
      <React.StrictMode>
        <App stripePromise={stripePromise} />
      </React.StrictMode>
    </Elements>
  </BrowserRouter>
);
